import React from "react";
import AppUser from "js/stores/AppUser"

const UserAvatar = ({onClick}) => {
    return (
        <div className="user-avatar" onClick={onClick}>
            <div className="user-avatar__initials">
                <span>
                {AppUser.avatar
                  ? <img style={{
                    borderRadius: '50px',
                    width: '2.625rem',
                    height: '2.625rem',
                    backgroundColor: 'rgba(0, 22, 255, 0.2)',
                    cursor: 'pointer',
                    transition: 'all 0.25s ease-in-out',
                    marginTop: '-3px'
                  }} src={AppUser.avatar} alt="Avatar" />
                  : AppUser.first_name
                    ? AppUser.first_name[0]
                    : '👤'}
                </span>
            </div>
        </div>
    );
};

export default UserAvatar;
